module.exports = __webpack_public_path__ + "static/media/jake-jacobson.f9927f26.jpg";